import { render, staticRenderFns } from "./u-header-foot-basic.vue?vue&type=template&id=82d2a632&scoped=true&"
import script from "./u-header-foot-basic.vue?vue&type=script&lang=js&"
export * from "./u-header-foot-basic.vue?vue&type=script&lang=js&"
import style0 from "./u-header-foot-basic.vue?vue&type=style&index=0&id=82d2a632&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d2a632",
  null
  
)

export default component.exports